// extracted by mini-css-extract-plugin
export var box = "_91-1";
export var checked = "_91-2";
export var descriptionSpacer = "_91-9";
export var disabled = "_91-3";
export var icon = "_91-6";
export var input = "_91-0";
export var labelSpacer = "_91-8";
export var medium = "_91-5";
export var small = "_91-4";
export var text = "_91-7";